const desktopRoutes = [
    {
        path: '/',
        component: () => import('@/pages/Desktop/index.vue'),
        children:[
            {
                path: '/',
                component: () => import('@/pages/Desktop/home.vue'),
                meta:{
                    title:"首页",
                    requiresAuth:false,
                }
            },
            {
                path: 'chat',
                component: () => import('@/pages/Desktop/Chat/chat.vue'),
                meta:{
                    title:"聊天",
                    requiresAuth:false,
                }
            },
            {
                path:'find',
                component: () => import('@/pages/Desktop/Find/find.vue'),
                meta:{
                    title:"发现",
                    requiresAuth:false,
                }
            },
            {
                path:'my',
                component: () => import('@/pages/Desktop/My/my.vue'),
                meta:{
                    title:"我的",
                    requiresAuth:true,
                }
            },
            {
                path:'login',
                component: () => import('@/pages/Desktop/Login/login.vue'),
                meta:{
                    title:"登录",
                    requiresAuth:false,
                }
            },
            {
                path:'myapp',
                component: () => import('@/pages/Desktop/Find/components/myapp.vue'),
                meta:{
                    title:"我的应用",
                    requiresAuth:true,
                }
            },
        ]
    },
]

export default desktopRoutes;